import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "./Logo";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import Form from "react-bootstrap/Form"
import {useHistory} from "react-router";
import {Link} from "react-router-dom";

function AppHeader(props){
    return <header className="shadow">
        <HeaderLine1 liste={props.liste}/>
        <HeaderLine2 categorie={props.categorie}
                     currentCategoria={props.currentCategoria}
                     setCurrentCategoria={props.setCurrentCategoria}
                     isList={props.isList}/>
    </header>
}

function HeaderLine1(props){
    let tot_liste = props.liste.reduce((tot, {nElementi}) => tot + nElementi, 0);

    return <Row>
        <Col xs={3}></Col>
        <Col xs={6}>
            <Logo />
        </Col>
        <Col xs={3} className={"d-none d-md-block"}>
            <Link to={`${process.env.PUBLIC_URL}/riepilogo-ordine`}>
                <Button variant={"link"} className={"headerButton"}>
                    <i className="fas fa-shopping-bag"></i>
                    <span> </span>
                    <Badge variant={"light"}>{tot_liste}</Badge>
                </Button>
            </Link>
        </Col>

    </Row>
}

function HeaderLine2(props){
    return <Row id={"categoriaHeader"}>
        {!props.isList && <CategoriaSelect categorie={props.categorie}
                                           currentCategoria={props.currentCategoria}
                                           setCurrentCategoria={props.setCurrentCategoria}
                                           isList={props.isList}/>
        }
        {props.isList && <>
            <Col xs={2}>
                <Link to={'/'}>
                    <Button variant={"link"}><i className="fas fa-arrow-left"></i></Button>
                </Link>
            </Col>
            <Col xs={8} id="categoriaTitle">
                Il tuo ordine
            </Col>
        </>}
    </Row>
}

function CategoriaSelect(props){
    let history = useHistory();
    let change_categoria = (categoria) => {
        let cat = props.categorie.find((c) => {
            return c.id === categoria;
        });
        history.push(`${process.env.PUBLIC_URL}/categoria/${cat.id}/${encodeURI(cat.nome)}`);
        window.scrollTo(0,0);
    }

    let currentCat = props.currentCategoria ? props.currentCategoria.id : 0;

    return <Col xs={12} id="categoriaTitle">
        <Form.Control as="select" onChange={(ev) => change_categoria(ev.target.value)}
                      value={currentCat}
                      custom>
            {props.categorie.map((c) =>
                <option value={c.id}
                        key={c.id}>{c.nome}</option>
            )}
        </Form.Control>
    </Col>
}

export default AppHeader;